// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Radio-module__font-s-10___kgCvb {
  font-size: 10px !important;
}

.Radio-module__font-s-12___q_wkM {
  font-size: 12px !important;
}

.Radio-module__font-s-13___s8JQl {
  font-size: 13px !important;
}

.Radio-module__font-s-14___QTZ5y {
  font-size: 14px !important;
}

.Radio-module__font-s-15___gozxY {
  font-size: 15px !important;
}

.Radio-module__font-s-16___iAO4T {
  font-size: 16px !important;
}

.Radio-module__font-s-18___dnm9B {
  font-size: 18px !important;
}

.Radio-module__font-s-20___EgMO3 {
  font-size: 20px !important;
}

.Radio-module__font-s-22___jmCvm {
  font-size: 22px !important;
}

.Radio-module__font-s-28___D1id3 {
  font-size: 28px !important;
}

.Radio-module__font-w-400___mGNrI {
  font-weight: 400 !important;
}

.Radio-module__font-w-500___Tc0zj {
  font-weight: 500 !important;
}

.Radio-module__font-w-600___csR14 {
  font-weight: 600 !important;
}

.Radio-module__font-w-700___hCBU7 {
  font-weight: 700 !important;
}

.Radio-module__p-5___OqzXS {
  padding: 5px !important;
}

.Radio-module__p-12___V7C9_ {
  padding: 12px !important;
}

.Radio-module__p-16___bTbkg {
  padding: 16px !important;
}

.Radio-module__p-30___lksE9 {
  padding: 30px !important;
}

.Radio-module__p-b-0___ud_e4 {
  padding-bottom: 0 !important;
}

.Radio-module__p-b-5___Xa_ms {
  padding-bottom: 5px !important;
}

.Radio-module__p-b-10___D7uE9 {
  padding-bottom: 10px !important;
}

.Radio-module__p-b-12___Jj4Al {
  padding-bottom: 12px !important;
}

.Radio-module__p-b-16___nZ5Zj {
  padding-bottom: 16px !important;
}

.Radio-module__p-b-18___lpaiC {
  padding-bottom: 18px !important;
}

.Radio-module__p-b-20___fMNgA {
  padding-bottom: 20px !important;
}

.Radio-module__p-b-25____x5wN {
  padding-bottom: 25px !important;
}

.Radio-module__p-b-30___OdFRI {
  padding-bottom: 30px !important;
}

.Radio-module__p-b-50___BB272 {
  padding-bottom: 50px !important;
}

.Radio-module__p-t-0___lH2j7 {
  padding-top: 0 !important;
}

.Radio-module__p-t-12___VHseI {
  padding-top: 12px !important;
}

.Radio-module__p-t-16___zDYZh {
  padding-top: 16px !important;
}

.Radio-module__p-t-18___QNriR {
  padding-top: 18px !important;
}

.Radio-module__p-t-20___qTvVL {
  padding-top: 20px !important;
}

.Radio-module__p-t-30___thNVW {
  padding-top: 30px !important;
}

.Radio-module__p-t-40___pkztQ {
  padding-top: 40px !important;
}

.Radio-module__p-t-50___NB78Z {
  padding-top: 50px !important;
}

.Radio-module__p-l-20___EUkok {
  padding-left: 20px !important;
}

.Radio-module__p-l-30___IegxZ {
  padding-left: 30px !important;
}

.Radio-module__p-l-40___iwF6i {
  padding-left: 40px !important;
}

.Radio-module__p-r-16___vUy_5 {
  padding-right: 16px !important;
}

.Radio-module__p-r-20___ORjjK {
  padding-right: 20px !important;
}

.Radio-module__p-r-30___vA2Eg {
  padding-right: 30px !important;
}

.Radio-module__p-r-50___xWMpR {
  padding-right: 50px !important;
}

.Radio-module__p-r-60___Sqrys {
  padding-right: 60px !important;
}

.Radio-module__m-b-1___zIvQ6 {
  margin-bottom: 1px !important;
}

.Radio-module__m-b-2____E2Sr {
  margin-bottom: 2px !important;
}

.Radio-module__m-b-6___JkGXa {
  margin-bottom: 6px !important;
}

.Radio-module__m-b-8___TyFuI {
  margin-bottom: 8px !important;
}

.Radio-module__m-b-10___VhzcN {
  margin-bottom: 10px !important;
}

.Radio-module__m-b-14___HU3if {
  margin-bottom: 14px !important;
}

.Radio-module__m-b-16___vU3BJ {
  margin-bottom: 16px !important;
}

.Radio-module__m-b-20___kE41P {
  margin-bottom: 20px !important;
}

.Radio-module__m-b-22___y01XK {
  margin-bottom: 22px !important;
}

.Radio-module__m-b-24___Bzxab {
  margin-bottom: 24px !important;
}

.Radio-module__m-b-30___j6MNG {
  margin-bottom: 30px !important;
}

.Radio-module__m-b-32___qfOq4 {
  margin-bottom: 32px !important;
}

.Radio-module__m-b-40____GM58 {
  margin-bottom: 40px !important;
}

.Radio-module__m-t-2___MzmwH {
  margin-top: 2px !important;
}

.Radio-module__m-t-3___oN7mK {
  margin-top: 3px !important;
}

.Radio-module__m-t-4___E5luP {
  margin-top: 4px !important;
}

.Radio-module__m-t-5___w_YsP {
  margin-top: 5px !important;
}

.Radio-module__m-t-8___brxPI {
  margin-top: 8px !important;
}

.Radio-module__m-t-10___Gbz7n {
  margin-top: 10px !important;
}

.Radio-module__m-t-15___XRit4 {
  margin-top: 15px !important;
}

.Radio-module__m-t-16___VGeDY {
  margin-top: 16px !important;
}

.Radio-module__m-t-20___nmo6B {
  margin-top: 20px !important;
}

.Radio-module__m-t-22___FZc_w {
  margin-top: 22px !important;
}

.Radio-module__m-t-30___cYl_B {
  margin-top: 30px !important;
}

.Radio-module__m-t-32___iPQro {
  margin-top: 32px !important;
}

.Radio-module__m-l-auto___avhvy {
  margin-left: auto !important;
}

.Radio-module__m-l-4___vvf18 {
  margin-left: 4px !important;
}

.Radio-module__m-l-5___U9tlp {
  margin-left: 5px !important;
}

.Radio-module__m-l-6___xFlwo {
  margin-left: 6px !important;
}

.Radio-module__m-l-8___whpcu {
  margin-left: 8px !important;
}

.Radio-module__m-l-10___YYtrf {
  margin-left: 10px !important;
}

.Radio-module__m-l-16___lJBKR {
  margin-left: 16px !important;
}

.Radio-module__m-l-20___gIqI0 {
  margin-left: 20px !important;
}

.Radio-module__m-l-24___aT_0F {
  margin-left: 24px !important;
}

.Radio-module__m-l-30___GMOUc {
  margin-left: 30px !important;
}

.Radio-module__m-l-35___pRaHI {
  margin-left: 35px !important;
}

.Radio-module__m-l-40___sAnAz {
  margin-left: 40px !important;
}

.Radio-module__m-r-8___pN_mI {
  margin-right: 8px !important;
}

.Radio-module__m-r-10___Lud3v {
  margin-right: 10px !important;
}

.Radio-module__m-r-16___sggl2 {
  margin-right: 16px !important;
}

.Radio-module__m-r-20___mdQHW {
  margin-right: 20px !important;
}

.Radio-module__m-r-24___V51G0 {
  margin-right: 24px !important;
}

.Radio-module__m-r-30___xepRq {
  margin-right: 30px !important;
}

.Radio-module__m-r-40___ai8Mb {
  margin-right: 40px !important;
}

.Radio-module__border-r-3___gNVmK {
  border-radius: 3px !important;
}

.Radio-module__border-r-4___Csdkx {
  border-radius: 4px !important;
}

.Radio-module__border-r-6___uQjL_ {
  border-radius: 6px !important;
}

.Radio-module__border-r-10___WJMfI {
  border-radius: 10px !important;
}

.Radio-module__border-r-12___ieNVd {
  border-radius: 12px !important;
}

.Radio-module__border-r-16___zM8Ni {
  border-radius: 16px !important;
}

.Radio-module__border-r-50___I2ojA {
  border-radius: 50% !important;
}

.Radio-module__primary-border___nxnb2 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Radio-module__primary-border-b___Qp48Y {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Radio-module__primary-border-t___MLf6O {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Radio-module__primary-border-l___lnyEq {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Radio-module__primary-border-r___Q3UTd {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Radio-module__secondary-border___JQw95 {
  border: 1px solid #637768;
}

.Radio-module__secondary-border-b___IIDnE {
  border-bottom: 1px solid #637768;
}

.Radio-module__secondary-border-t___XH69A {
  border-top: 1px solid #637768;
}

.Radio-module__secondary-border-l___V5TOq {
  border-left: 1px solid #637768;
}

.Radio-module__secondary-border-r___FQEMp {
  border-right: 1px solid #637768;
}

.Radio-module__gap-0___lwFIY {
  gap: 0 !important;
}

.Radio-module__gap-2___BncTp {
  gap: 2px !important;
}

.Radio-module__gap-4___yQQ10 {
  gap: 4px !important;
}

.Radio-module__gap-5___o3akO {
  gap: 5px !important;
}

.Radio-module__gap-6___Yj9mY {
  gap: 6px !important;
}

.Radio-module__gap-8___lG_eZ {
  gap: 8px !important;
}

.Radio-module__gap-10___v1c7S {
  gap: 10px !important;
}

.Radio-module__gap-12___iF7QT {
  gap: 12px !important;
}

.Radio-module__gap-14___ZUkZV {
  gap: 14px !important;
}

.Radio-module__gap-16___wpvmr {
  gap: 16px !important;
}

.Radio-module__gap-18___lXdXR {
  gap: 18px !important;
}

.Radio-module__gap-20___cmjFw {
  gap: 20px !important;
}

.Radio-module__gap-24___IkcMc {
  gap: 24px !important;
}

.Radio-module__gap-26___chSd2 {
  gap: 26px !important;
}

.Radio-module__gap-30___CW3aJ {
  gap: 30px !important;
}

.Radio-module__gap-32___MoTnS {
  gap: 32px !important;
}

.Radio-module__gap-40___y8EV8 {
  gap: 40px !important;
}

.Radio-module__gap-50___IohBd {
  gap: 50px !important;
}

.Radio-module__flex-1___wBBIW {
  flex: 1;
}

.Radio-module__flex-none___RBPIQ {
  flex: none !important;
}

.Radio-module__flex-column___JEb1a {
  display: flex;
  flex-direction: column !important;
}

.Radio-module__flex-row___Lm1ZC {
  display: flex;
  flex-direction: row !important;
}

.Radio-module__vertically-centered___hImnp {
  display: flex;
  align-items: center !important;
}

.Radio-module__horizontally-centered___oaByH {
  display: flex;
  justify-content: center !important;
}

.Radio-module__horizontally-end___fGbdh {
  display: flex;
  justify-content: end !important;
}

.Radio-module__vertically-start___G79Us {
  display: flex;
  align-items: start !important;
}

.Radio-module__space-between___LmaAa {
  display: flex;
  justify-content: space-between !important;
}

.Radio-module__flex-wrap___KjjAZ {
  flex-wrap: wrap !important;
}

.Radio-module__height-100___Je7Ok {
  height: 100%;
}

.Radio-module__width-50___Hw8JO {
  width: 50% !important;
}

.Radio-module__width-100___hgFCa {
  width: 100%;
}

.Radio-module__cursor-pointer___RgMdT {
  cursor: pointer;
}

.Radio-module__cursor-not-allowed___vneMA {
  cursor: not-allowed !important;
}

.Radio-module__absolute-centered___ya1wL {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Radio-module__absolute___diXOK {
  position: absolute;
}

.Radio-module__relative___GWFqM {
  position: relative;
}

.Radio-module__fixed___gA7OH {
  position: fixed;
}

.Radio-module__visible___yOs7D {
  opacity: 1;
}

.Radio-module__invisible___C8vWq {
  opacity: 0;
}

.Radio-module__col-90___hMbHe {
  width: 90% !important;
}

.Radio-module__col-auto___gXMdK {
  width: auto !important;
}

.Radio-module__medical-tabs___S03uG {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Radio-module__medical-table-new___lTJPs {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Radio-module__medical-table-new___lTJPs:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Radio-module__medical-table-new___lTJPs::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Radio-module__medical-table-new___lTJPs::-webkit-scrollbar-track {
  display: none;
}
.Radio-module__medical-table-new___lTJPs.Radio-module__no-pagination___EMxg9 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Radio-module__medical-table-new___lTJPs.Radio-module__no-pagination___EMxg9:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Radio-module__medical-table-new___lTJPs.Radio-module__no-pagination___EMxg9::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Radio-module__medical-table-new___lTJPs.Radio-module__no-pagination___EMxg9::-webkit-scrollbar-track {
  display: none;
}

.Radio-module__medical-table-empty___qZl4J {
  padding: 14px 40px !important;
}

.Radio-module__icon-btn___TWQOz {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Radio-module__search-icon___Evtwb {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Radio-module__disable-select___Ky3KU {
  user-select: none;
}

.Radio-module__break-word___ZE_zO {
  word-break: break-word;
}

.Radio-module__popup-clear-btn___nZrRm {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Radio-module__scroll-m-b-20___OP4qG {
  scroll-margin-bottom: 20px;
}

.Radio-module__container___GYAGo {
  color: #375844;
  width: fit-content;
  cursor: pointer;
}
.Radio-module__container___GYAGo.Radio-module__disabled___fvYMs {
  opacity: 0.6;
  cursor: not-allowed;
}
.Radio-module__container___GYAGo.Radio-module__vertical___zGL75 {
  font-size: 12px;
  flex-direction: column-reverse;
}
.Radio-module__container___GYAGo.Radio-module__checked___LzwVS {
  background-color: #f1f6f2;
}
.Radio-module__container___GYAGo .Radio-module__radio___vq_fT {
  border: 1px solid #375844;
  min-height: 20px;
  min-width: 20px;
}
.Radio-module__container___GYAGo .Radio-module__radio___vq_fT.Radio-module__checked___LzwVS {
  box-shadow: 0 0 0 1px #375844;
}
.Radio-module__container___GYAGo .Radio-module__radio___vq_fT input:checked + .Radio-module__check___rRFw6 {
  background-color: #375844;
  border-radius: 50%;
  height: 10px;
  width: 10px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./../common/src/components/base/Radio/Radio.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;AA8pBF;AA5pBE;EACE,YAAA;EACA,mBAAA;AA8pBJ;AA3pBE;EACE,eAAA;EACA,8BAAA;AA6pBJ;AA1pBE;EACE,yBAAA;AA4pBJ;AAzpBE;EACE,yBAAA;EACA,gBAAA;EACA,eAAA;AA2pBJ;AAzpBI;EACE,6BAAA;AA2pBN;AAxpBI;EACE,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AA0pBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  color: get-color(greenNew, dark);\n  width: fit-content;\n  cursor: pointer;\n\n  &.disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n\n  &.vertical {\n    font-size: 12px;\n    flex-direction: column-reverse;\n  }\n\n  &.checked {\n    background-color: get-color(greenNew, ultra-light);\n  }\n\n  .radio {\n    border: 1px solid get-color(greenNew, dark);\n    min-height: 20px;\n    min-width: 20px;\n\n    &.checked {\n      box-shadow: 0 0 0 1px get-color(greenNew, dark);\n    }\n\n    input:checked + .check {\n      background-color: get-color(greenNew, dark);\n      border-radius: 50%;\n      height: 10px;\n      width: 10px;\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Radio-module__font-s-10___kgCvb`,
	"fontS12": `Radio-module__font-s-12___q_wkM`,
	"fontS13": `Radio-module__font-s-13___s8JQl`,
	"fontS14": `Radio-module__font-s-14___QTZ5y`,
	"fontS15": `Radio-module__font-s-15___gozxY`,
	"fontS16": `Radio-module__font-s-16___iAO4T`,
	"fontS18": `Radio-module__font-s-18___dnm9B`,
	"fontS20": `Radio-module__font-s-20___EgMO3`,
	"fontS22": `Radio-module__font-s-22___jmCvm`,
	"fontS28": `Radio-module__font-s-28___D1id3`,
	"fontW400": `Radio-module__font-w-400___mGNrI`,
	"fontW500": `Radio-module__font-w-500___Tc0zj`,
	"fontW600": `Radio-module__font-w-600___csR14`,
	"fontW700": `Radio-module__font-w-700___hCBU7`,
	"p5": `Radio-module__p-5___OqzXS`,
	"p12": `Radio-module__p-12___V7C9_`,
	"p16": `Radio-module__p-16___bTbkg`,
	"p30": `Radio-module__p-30___lksE9`,
	"pB0": `Radio-module__p-b-0___ud_e4`,
	"pB5": `Radio-module__p-b-5___Xa_ms`,
	"pB10": `Radio-module__p-b-10___D7uE9`,
	"pB12": `Radio-module__p-b-12___Jj4Al`,
	"pB16": `Radio-module__p-b-16___nZ5Zj`,
	"pB18": `Radio-module__p-b-18___lpaiC`,
	"pB20": `Radio-module__p-b-20___fMNgA`,
	"pB25": `Radio-module__p-b-25____x5wN`,
	"pB30": `Radio-module__p-b-30___OdFRI`,
	"pB50": `Radio-module__p-b-50___BB272`,
	"pT0": `Radio-module__p-t-0___lH2j7`,
	"pT12": `Radio-module__p-t-12___VHseI`,
	"pT16": `Radio-module__p-t-16___zDYZh`,
	"pT18": `Radio-module__p-t-18___QNriR`,
	"pT20": `Radio-module__p-t-20___qTvVL`,
	"pT30": `Radio-module__p-t-30___thNVW`,
	"pT40": `Radio-module__p-t-40___pkztQ`,
	"pT50": `Radio-module__p-t-50___NB78Z`,
	"pL20": `Radio-module__p-l-20___EUkok`,
	"pL30": `Radio-module__p-l-30___IegxZ`,
	"pL40": `Radio-module__p-l-40___iwF6i`,
	"pR16": `Radio-module__p-r-16___vUy_5`,
	"pR20": `Radio-module__p-r-20___ORjjK`,
	"pR30": `Radio-module__p-r-30___vA2Eg`,
	"pR50": `Radio-module__p-r-50___xWMpR`,
	"pR60": `Radio-module__p-r-60___Sqrys`,
	"mB1": `Radio-module__m-b-1___zIvQ6`,
	"mB2": `Radio-module__m-b-2____E2Sr`,
	"mB6": `Radio-module__m-b-6___JkGXa`,
	"mB8": `Radio-module__m-b-8___TyFuI`,
	"mB10": `Radio-module__m-b-10___VhzcN`,
	"mB14": `Radio-module__m-b-14___HU3if`,
	"mB16": `Radio-module__m-b-16___vU3BJ`,
	"mB20": `Radio-module__m-b-20___kE41P`,
	"mB22": `Radio-module__m-b-22___y01XK`,
	"mB24": `Radio-module__m-b-24___Bzxab`,
	"mB30": `Radio-module__m-b-30___j6MNG`,
	"mB32": `Radio-module__m-b-32___qfOq4`,
	"mB40": `Radio-module__m-b-40____GM58`,
	"mT2": `Radio-module__m-t-2___MzmwH`,
	"mT3": `Radio-module__m-t-3___oN7mK`,
	"mT4": `Radio-module__m-t-4___E5luP`,
	"mT5": `Radio-module__m-t-5___w_YsP`,
	"mT8": `Radio-module__m-t-8___brxPI`,
	"mT10": `Radio-module__m-t-10___Gbz7n`,
	"mT15": `Radio-module__m-t-15___XRit4`,
	"mT16": `Radio-module__m-t-16___VGeDY`,
	"mT20": `Radio-module__m-t-20___nmo6B`,
	"mT22": `Radio-module__m-t-22___FZc_w`,
	"mT30": `Radio-module__m-t-30___cYl_B`,
	"mT32": `Radio-module__m-t-32___iPQro`,
	"mLAuto": `Radio-module__m-l-auto___avhvy`,
	"mL4": `Radio-module__m-l-4___vvf18`,
	"mL5": `Radio-module__m-l-5___U9tlp`,
	"mL6": `Radio-module__m-l-6___xFlwo`,
	"mL8": `Radio-module__m-l-8___whpcu`,
	"mL10": `Radio-module__m-l-10___YYtrf`,
	"mL16": `Radio-module__m-l-16___lJBKR`,
	"mL20": `Radio-module__m-l-20___gIqI0`,
	"mL24": `Radio-module__m-l-24___aT_0F`,
	"mL30": `Radio-module__m-l-30___GMOUc`,
	"mL35": `Radio-module__m-l-35___pRaHI`,
	"mL40": `Radio-module__m-l-40___sAnAz`,
	"mR8": `Radio-module__m-r-8___pN_mI`,
	"mR10": `Radio-module__m-r-10___Lud3v`,
	"mR16": `Radio-module__m-r-16___sggl2`,
	"mR20": `Radio-module__m-r-20___mdQHW`,
	"mR24": `Radio-module__m-r-24___V51G0`,
	"mR30": `Radio-module__m-r-30___xepRq`,
	"mR40": `Radio-module__m-r-40___ai8Mb`,
	"borderR3": `Radio-module__border-r-3___gNVmK`,
	"borderR4": `Radio-module__border-r-4___Csdkx`,
	"borderR6": `Radio-module__border-r-6___uQjL_`,
	"borderR10": `Radio-module__border-r-10___WJMfI`,
	"borderR12": `Radio-module__border-r-12___ieNVd`,
	"borderR16": `Radio-module__border-r-16___zM8Ni`,
	"borderR50": `Radio-module__border-r-50___I2ojA`,
	"primaryBorder": `Radio-module__primary-border___nxnb2`,
	"primaryBorderB": `Radio-module__primary-border-b___Qp48Y`,
	"primaryBorderT": `Radio-module__primary-border-t___MLf6O`,
	"primaryBorderL": `Radio-module__primary-border-l___lnyEq`,
	"primaryBorderR": `Radio-module__primary-border-r___Q3UTd`,
	"secondaryBorder": `Radio-module__secondary-border___JQw95`,
	"secondaryBorderB": `Radio-module__secondary-border-b___IIDnE`,
	"secondaryBorderT": `Radio-module__secondary-border-t___XH69A`,
	"secondaryBorderL": `Radio-module__secondary-border-l___V5TOq`,
	"secondaryBorderR": `Radio-module__secondary-border-r___FQEMp`,
	"gap0": `Radio-module__gap-0___lwFIY`,
	"gap2": `Radio-module__gap-2___BncTp`,
	"gap4": `Radio-module__gap-4___yQQ10`,
	"gap5": `Radio-module__gap-5___o3akO`,
	"gap6": `Radio-module__gap-6___Yj9mY`,
	"gap8": `Radio-module__gap-8___lG_eZ`,
	"gap10": `Radio-module__gap-10___v1c7S`,
	"gap12": `Radio-module__gap-12___iF7QT`,
	"gap14": `Radio-module__gap-14___ZUkZV`,
	"gap16": `Radio-module__gap-16___wpvmr`,
	"gap18": `Radio-module__gap-18___lXdXR`,
	"gap20": `Radio-module__gap-20___cmjFw`,
	"gap24": `Radio-module__gap-24___IkcMc`,
	"gap26": `Radio-module__gap-26___chSd2`,
	"gap30": `Radio-module__gap-30___CW3aJ`,
	"gap32": `Radio-module__gap-32___MoTnS`,
	"gap40": `Radio-module__gap-40___y8EV8`,
	"gap50": `Radio-module__gap-50___IohBd`,
	"flex1": `Radio-module__flex-1___wBBIW`,
	"flexNone": `Radio-module__flex-none___RBPIQ`,
	"flexColumn": `Radio-module__flex-column___JEb1a`,
	"flexRow": `Radio-module__flex-row___Lm1ZC`,
	"verticallyCentered": `Radio-module__vertically-centered___hImnp`,
	"horizontallyCentered": `Radio-module__horizontally-centered___oaByH`,
	"horizontallyEnd": `Radio-module__horizontally-end___fGbdh`,
	"verticallyStart": `Radio-module__vertically-start___G79Us`,
	"spaceBetween": `Radio-module__space-between___LmaAa`,
	"flexWrap": `Radio-module__flex-wrap___KjjAZ`,
	"height100": `Radio-module__height-100___Je7Ok`,
	"width50": `Radio-module__width-50___Hw8JO`,
	"width100": `Radio-module__width-100___hgFCa`,
	"cursorPointer": `Radio-module__cursor-pointer___RgMdT`,
	"cursorNotAllowed": `Radio-module__cursor-not-allowed___vneMA`,
	"absoluteCentered": `Radio-module__absolute-centered___ya1wL`,
	"absolute": `Radio-module__absolute___diXOK`,
	"relative": `Radio-module__relative___GWFqM`,
	"fixed": `Radio-module__fixed___gA7OH`,
	"visible": `Radio-module__visible___yOs7D`,
	"invisible": `Radio-module__invisible___C8vWq`,
	"col90": `Radio-module__col-90___hMbHe`,
	"colAuto": `Radio-module__col-auto___gXMdK`,
	"medicalTabs": `Radio-module__medical-tabs___S03uG`,
	"medicalTableNew": `Radio-module__medical-table-new___lTJPs`,
	"noPagination": `Radio-module__no-pagination___EMxg9`,
	"medicalTableEmpty": `Radio-module__medical-table-empty___qZl4J`,
	"iconBtn": `Radio-module__icon-btn___TWQOz`,
	"searchIcon": `Radio-module__search-icon___Evtwb`,
	"disableSelect": `Radio-module__disable-select___Ky3KU`,
	"breakWord": `Radio-module__break-word___ZE_zO`,
	"popupClearBtn": `Radio-module__popup-clear-btn___nZrRm`,
	"scrollMB20": `Radio-module__scroll-m-b-20___OP4qG`,
	"container": `Radio-module__container___GYAGo`,
	"disabled": `Radio-module__disabled___fvYMs`,
	"vertical": `Radio-module__vertical___zGL75`,
	"checked": `Radio-module__checked___LzwVS`,
	"radio": `Radio-module__radio___vq_fT`,
	"check": `Radio-module__check___rRFw6`
};
module.exports = ___CSS_LOADER_EXPORT___;
